import { render, staticRenderFns } from "./BoardSimilarity.vue?vue&type=template&id=07bc61cb&scoped=true&"
import script from "./BoardSimilarity.vue?vue&type=script&lang=js&"
export * from "./BoardSimilarity.vue?vue&type=script&lang=js&"
import style0 from "./BoardSimilarity.vue?vue&type=style&index=0&id=07bc61cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc61cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07bc61cb')) {
      api.createRecord('07bc61cb', component.options)
    } else {
      api.reload('07bc61cb', component.options)
    }
    module.hot.accept("./BoardSimilarity.vue?vue&type=template&id=07bc61cb&scoped=true&", function () {
      api.rerender('07bc61cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/patient/components/Home/components/BoardSimilarity.vue"
export default component.exports